export default __webpack_public_path__ + "static/media/graduate.859eeeb1.png";